<template>
	<!-- 矩阵填空  矩阵填空-->
	<div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">矩阵填空</p>
		<el-row :gutter="10" class="question-box">
			<el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">{{ question.quesIndex + 1 }}</el-col>
			<el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title">
				<span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{ question.questionsName }}</span>
				<TitleEditor
					:isTest="true"
					class="outline-none"
					:qid="question.qid"
					:class="question.qid"
					:value="question.questionsName"
					@childValueChange="
						val => {
							question.questionsName = val;
						}
					"
				></TitleEditor>
			</el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<template>
					<el-dropdown v-if="!$route.query.bankId" @visible-change="getBankList" :hide-on-click="false" ref="bankDropdown" trigger="click">
						<span class="el-dropdown-link">
							<el-tooltip content="收藏到题库" placement="top" effect="light">
								<i v-if="question.isedit && !question.bqid" class="el-icon-star-off to-bank item"></i>
							</el-tooltip>
						</span>
						<el-dropdown-menu slot="dropdown">
							<div class="scroll-body" style="overflow-y: auto;" :style="{ maxHeight: isAddBank ? '102px' : '200px' }">
								<el-dropdown-item class="dropdown-item" v-for="item in bankList" :key="item.id">
									<span>{{ item.name }}</span>
									<el-button class="btn" size="mini" @click="addToBank(item.id)" type="text">添加</el-button>
								</el-dropdown-item>
								<el-dropdown-item
									disabled
									style="
								font-size: 12px;
								color: #ccc"
									class="dropdown-item"
									v-if="bankList.length == 0"
								>
									<span>暂无题库</span>
								</el-dropdown-item>
							</div>

							<el-dropdown-item v-if="isAddBank" divided style="text-align:center">
								<el-form :model="bankForm" ref="ValidateForm" style="margin-bottom: 0;" class="demo-ruleForm">
									<el-form-item prop="name" :rules="[{ required: true, message: '不能为空' }]">
										<el-input size="mini" v-model="bankForm.name"></el-input>
									</el-form-item>
									<el-form-item size="mini" style="text-align: right;margin-bottom: 0;">
										<el-button type="text" @click="addBank">创建</el-button>
										<el-button type="text" @click="cancelAddBank">取消</el-button>
									</el-form-item>
								</el-form>
							</el-dropdown-item>

							<el-dropdown-item divided style="text-align:center">
								<el-button @click="isAddBank = true" style="width:178px;" icon="el-icon-circle-plus-outline" type="text">新建题库</el-button>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<el-tooltip content="取消收藏" placement="top" effect="light">
						<i class="form-bank item el-icon-star-on" v-if="question.isedit && question.bqid" @click="delFormBank"></i>
					</el-tooltip>
				</template>
				<template v-if="!isBankViewTest">
					<div @click="() => $emit('jumpshow', question)">
						<el-badge v-if="question.logicalSettings.num" :value="question.logicalSettings.num" class="item"><i class="el-icon-share"></i></el-badge>
					</div>
					<i class="el-icon-rank item drag-handle"></i>
					<i v-if="question.isedit" class="zxwj-iconfont zxwj-icon-fuzhi item" @click="copyClick(question)"></i>
					<i class="el-icon-delete delete" v-if="question.isedit" @click="questiondel(question.qid)"></i>
				</template>
			</el-col>
		</el-row>

		<div style="max-width: 1100px; overflow-x: auto;">
			<table>
				<tr>
					<th class="td_width"></th>
					<th
						class="td_width"
						style="text-align: center"
						:style="{ width: option.columnWidth + option.columnWidthUnit + ' !important' }"
						v-for="(option, index2) in questionsSonList[0].optionList"
						:key="index2"
					>
						<div class="table-th">
							<template>
								<span v-if="isBankViewTest">{{ option.labelName }}</span>
								<TitleEditor
									v-if="!isBankViewTest"
									class="outline-none"
									:qid="option.oid"
									:class="option.oid"
									:value="option.labelName"
									@childValueChange="val => columnsNameChange(val, option)"
								></TitleEditor>
							</template>
							<el-dropdown @command="c => wjdelquestionoption(questionsSonList[0].optionList, index2, c)">
								<span v-if="!isBankViewTest" class="el-dropdown-link"><i class="el-icon-arrow-down el-icon--right"></i></span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="删除">删除</el-dropdown-item>
									<!-- <el-dropdown-item command="设置" >设置</el-dropdown-item> -->
								</el-dropdown-menu>
							</el-dropdown>
						</div>
					</th>
				</tr>
				<tr v-for="(item, index) in questionsSonList" :key="item.SonId">
					<td class="td_width">
						<div class="table-th">
							<template>
								<span v-if="isBankViewTest">{{ item.questionsName }}</span>
								<TitleEditor
									v-if="!isBankViewTest"
									class="outline-none"
									:qid="item.SonId"
									:class="item.SonId"
									:value="item.questionsName"
									@childValueChange="val => rowNameChange(val, item)"
								></TitleEditor>
							</template>
							<el-dropdown @command="questiondel(question.qid, item.SonId)">
								<span v-if="!isBankViewTest" class="el-dropdown-link"><i class="el-icon-arrow-down el-icon--right"></i></span>
								<el-dropdown-menu slot="dropdown"><el-dropdown-item>删除</el-dropdown-item></el-dropdown-menu>
							</el-dropdown>
						</div>
					</td>
					<td class="td_width" style="text-align: center" v-for="(option, index2) in item.optionList" :key="index + '-' + index2">
						<el-select size="small" v-model="item.tempValue" placeholder="请选择" v-if="option.type == '10'">
							<el-option v-for="item in option.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
						<div v-else-if="option.type == '12'">
							 <el-button type="primary" disabled>上传文件</el-button>
						</div>
						<fake-input class="textval" v-else />
					</td>
				</tr>
			</table>
		</div>
		<el-row :gutter="10" style="margin-top: 12px !important" v-if="question.isedit && !isBankViewTest">
			<el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="el_item_option item_container_title" style="margin-left: 50px">
				<i class="el-icon-plus el-icon-common" @click="addRows">添加行</i>
				<i class="el-icon-plus el-icon-common" @click="addColumn">添加列</i>
				<!-- <i class="el-icon-plus el-icon-common" @click="$refs.batchAddRows.batchAddshow = true">批量添加行</i>
				<i class="el-icon-plus el-icon-common" @click="$refs.batchAddColumns.batchAddshow = true">批量添加列</i> -->
				<i class="el-icon-plus el-icon-common" @click="$refs.setColumnProperties.batchAddshow = true">设置列属性</i>
			</el-col>
		</el-row>

		<BatchAddOption ref="batchAddRows" :title="'矩阵行'" :functionName="'batchAddRows'" :question="question" @batchAddRows="batchAddRows" />
		<BatchAddOption
			ref="batchAddColumns"
			:title="'矩阵列'" 
			:functionName="'batchAddColumns'"
			:question="question"
			@batchAddColumns="batchAddColumns"
		/>
		<setColumnProperties ref="setColumnProperties" :title="'设置列属性'" :functionName="'setColumnProperties'" :question="question" @addColumnProperties="addColumnProperties" />
	</div>
</template>
<script>
import FakeInput from '@/components/FakeInput.vue';
import TitleEditor from '@/components/titleEditor/titleEditor.vue';
import BatchAddOption from '@/components/myComponents/batchAddOption/batchAddOption.vue';
import setColumnProperties from '@/components/myComponents/batchAddOption/setColumnProperties.vue';
import { v1 as UUID } from 'uuid';
export default {
	components: {
		FakeInput,
		TitleEditor,
		BatchAddOption,
		setColumnProperties
	},
	data() {
		return {
			questionsSonList: [],
			jz: 'jz',
			// 题库start
			isAddBank: false,
			bankForm: {
				isSystemBank: 0, // 我的题库
				name: '',
				type: '未分类',
				bankType: 1
			}
			// 题库end
		};
	},
	props: {
		question: {
			type: Object,
			default: () => {
				return {};
			}
		},
		index: { type: Number, default: 0 },
		// 管理题库时查看试题 只可以删除
		isBankViewTest: {
			type: Boolean,
			default: false
		},
		bankList: {
			type: Array,
			default: () => {
				return [];
			}
		}
	},
	watch: {
		question: {
			handler(vnew, vold) {
				this.questionsSonList = vnew.questionsSonList;
			},
			deep: true,
			immediate: true
		},
		'question.questionsName': {
			handler(newV, oldV) {
				if (newV !== oldV && this.question.bqid) {
					this.question.bqid = '';
				}
			},
			deep: true
		},
		'question.questionsSonList.length': {
			handler(newV, oldV) {
				if (newV !== oldV && this.question.bqid) {
					this.question.bqid = '';
				}
			},
			deep: true
		}
	},
	methods: {
		addColumnProperties(optionArr) {
			console.log('optionArr确定',optionArr)
			// this.$emit('batchAddRows', optionArr);
		},
		copyClick(question) {
			this.$emit('questionCopy', question);
		},
		rowNameChange(val, data) {
			if (val !== data.questionsName) {
				this.setSonDefault();
				if (this.question.bqid) {
					this.question.bqid = '';
				}
			}
			data.questionsName = val;
		},
		setSonDefault() {
			this.question.questionsSonList = this.question.questionsSonList.map(info => {
				this.$set(info, 'isDefault', false);
				return info;
			});
		},
		columnsNameChange(val, data) {
			if (val !== data.labelName) {
				this.setOptionDefault();
				if (this.question.bqid) {
					this.question.bqid = '';
				}
			}
			data.labelName = val;
		},
		setOptionDefault() {
			this.question.questionsSonList = this.question.questionsSonList.map(info => {
				info.optionList = info.optionList.map(val => {
					this.$set(val, 'isDefault', false);
					return val;
				});
				return info;
			});
		},
		// watch(state) {
		// 	if (state == 'Rows') { // 监听

		// 	}
		// },
		// 题库start
		getBankList(e) {
			if (e) {
				this.$emit('getBankList');
			}
		},
		addToBank(id) {
			this.$refs.bankDropdown.hide();
			this.$emit('addToBank', this.question, id);
			console.log(this.question);
		},
		cancelAddBank() {
			this.isAddBank = false;
			this.bankForm.name = '';
		},
		addBank() {
			this.$refs.ValidateForm.validate(valid => {
				if (valid) {
					this.isAddBank = true;
					this.$emit('addBank', this.bankForm, this.question.qid);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
			// this.$refs.bankDropdown.show()
		},
		delFormBank() {
			this.$emit('delFormBank', this.question);
		},
		// 题库end
		addRows() {
			this.setSonDefault();
			// this.$emit('addRows', '填空');
			console.log('this.question',this.question)
			let length = this.question.questionsSonList.length;
			let length2 = this.question.questionsSonList[0].optionList.length;
			let questionsSonList = new Object();
			questionsSonList.SonId = UUID();
			questionsSonList.questionsName = `成员${length + 1}`;
			let haveInputArr = [],
				oidArr = [],
				labelNameArr = [];
			this.question.questionsSonList[0].optionList.forEach((e, i) => {
				if (e?.haveInput == true) {
					haveInputArr.push(i);
				}
				oidArr.push(e.oid);
				labelNameArr.push(e.labelName);
			});
			questionsSonList.optionList = new Array();
			for (var i = 0; i < length2; i++) {
				let option = new Object();
				option.oid = oidArr[i];
				option.labelName = labelNameArr[i];
				option = this.question.questionsSonList[0].optionList[i]
				questionsSonList.optionList.push(option);
			}
			this.question.questionsSonList.push(questionsSonList);
			console.log(this.question)
		},
		addColumn() {
			this.setOptionDefault();
			if (this.question.bqid) {
				this.question.bqid = '';
			}
			this.$emit('addColumn', '填空');
		},
		batchAddRows(optionArr) {
			this.$emit('batchAddRows', optionArr);
		},
		batchAddColumns(optionArr) {
			if (this.question.bqid) {
				this.question.bqid = '';
			}
			this.$emit('batchAddColumns', optionArr);
		},
		batchAdd(options, item, ifRow) {
			this.$emit('batchAdd', options, item, this.jz, this.question.id, ifRow);
		},
		//添加自题目
		wjaddquestionoption() {
			//this.question.questionsSonList.push({});
			this.$emit('addquestionitem', this.question);
		},
		setEditIndex(index) {
			this.$emit('setEditIndex', index);
		},
		setEditOptionIndex(childIndex) {
			this.$emit('setEditOptionIndex', childIndex);
		},
		wjdelquestionoption(optionList, index, command) {
			if (command == '删除') {
				if (optionList.length == 1) {
					this.$message.error('至少保留一条选项');
				} else {
					this.$emit('deleteOptionColumn', { index });
				}
			}
			if (command == '设置') {
				this.$emit('wjsetquestionoption', this.question, optionList, index, '矩阵');
			}
		},
		addmatrixquestionsoption(optionList, question) {
			this.$emit('addmatrixquestionsoption', optionList, question);
		},
		questiondel(id, pid) {
			if (pid && this.question.questionsSonList.length == 1) {
				this.$message({
					type: 'error',
					message: '至少保留一个子题目！'
				});
			} else {
				this.$emit('questiondel', id, pid);
			}
		}
	},
	created() {
		//console.log(JSON.stringify(this.question))
		let that = this;
		that.questionsSonList = this.question.questionsSonList;
	}
};
</script>

<style scoped lang="scss">
/deep/ .textval {
	border: 1px solid #ccc !important;
	width: 120px;
	height: 20px;
	margin: 0 auto;
}
table,
table td,
table th {
	border: 1px solid #ccc;
	border-collapse: collapse;
	margin-left: 45px;
	margin-bottom: 20px;
	margin-top: 40px;
	font-weight: normal;
}
tr {
	height: 30px;
}
.td_width {
	text-align: center;
	padding: 10px 20px;
}
.el-dropdown-link {
	cursor: pointer;
	color: #409eff;
	display: inline-block;
	margin-top: 5px;
}
.el-icon-arrow-down {
	font-size: 12px;
}
.delete,
.item {
	font-size: 22px !important;
	line-height: 40px !important;
	// margin-right: 30px !important;
	text-align: right;
	float: right;
	cursor: pointer;
}
.item .el-badge__content.is-fixed {
	top: 10px;
}
.item.drag-handle {
	cursor: move;
}
.el_item_option {
	line-height: 40px;
	height: 44px;
}

.el-icon-common {
	margin-right: 23px;
	font-size: 16px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}

.el-icon-common-option {
	margin-left: 10px;
	font-size: 22px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}

.item_container_title {
	padding-left: 0px !important;
	padding-right: 0px !important;
}

/deep/.el-textarea .el-textarea__inner {
	border: 1px solid #dcdfe6 !important;
	background-color: #fff;
}
.table-th {
	display: flex;
	justify-content: center;
}
</style>
